import mapboxgl from "mapbox-gl";

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

// This line can stay as it is if you're using the map component
mapboxgl.accessToken = MAPBOX_TOKEN;
